// Small red dot shown next to the Alerts sidebar nav entry when the
// caller's org has any active alerts. Spec (S11-6 AC): "shows red dot
// when > 0, updates on WS events". Doesn't display a number —
// presence/absence only. That keeps the sidebar visually quiet until
// something needs attention.
//
// Updates: useActiveAlertCount() is keyed under ['alerts', 'count']
// so AppShell's WS-driven invalidateQueries({ queryKey: ['alerts'] })
// refetches it on every alert.triggered / alert.resolved event.

import { useActiveAlertCount } from '../../hooks/useAlertsApi.js';

export default function AlertCountBadge() {
  const { data: hasActive } = useActiveAlertCount();
  if (!hasActive) return null;
  return (
    <span
      role="status"
      aria-label="Active alerts"
      className="inline-block h-2 w-2 rounded-full bg-red-500"
    />
  );
}
